module.exports = __webpack_public_path__ + "media/videos/autopilot/autopilot-promo1-choose-plan-4bb90d2a00021d269864527286af3845.mp4";